import { motion } from "framer-motion";
import { FadeUp, MaskLine } from "@/components/Reveal";
import { Mark } from "@/components/Logo";
import { useLang } from "@/context/LangContext";

export function Manifesto() {
  const { t, rtl } = useLang();
  return (
    <section id="house" data-testid="manifesto-section" className="relative overflow-hidden bg-[#F7F3EB] text-[#0B0B0C]">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-16 px-5 py-28 sm:px-10 lg:grid-cols-12 lg:gap-10 lg:py-40">
        <div className="lg:col-span-7">
          <FadeUp className="flex items-center gap-4">
            <span className="font-latin text-xs tracking-[0.3em] text-[#241914]/60">01</span>
            <span className="h-px w-10 bg-[#C6A76A]" />
            <span className="eyebrow !text-[#8a6d35]">{t("manifesto_over")}</span>
          </FadeUp>
          <h2 className={`font-display mt-10 text-[#0B0B0C] ${rtl ? "text-4xl leading-[1.6] sm:text-5xl lg:text-6xl" : "text-4xl leading-[1.08] sm:text-5xl lg:text-[4.4rem]"}`}>
            <MaskLine inView>{t("manifesto_1")}</MaskLine>
          </h2>
          <FadeUp delay={0.15}>
            <p className={`font-display mt-6 max-w-2xl text-[#241914]/85 ${rtl ? "text-2xl leading-[1.9] sm:text-3xl" : "text-2xl italic leading-snug sm:text-3xl"}`}>{t("manifesto_2")}</p>
          </FadeUp>
          <FadeUp delay={0.25} className="mt-14 grid max-w-2xl grid-cols-1 gap-8 border-t border-[#241914]/15 pt-10 sm:grid-cols-[auto_1fr]">
            <Mark className="h-14 w-12 text-[#C6A76A]" />
            <p className="text-base leading-loose text-[#241914]/80">{t("manifesto_p")}</p>
          </FadeUp>
        </div>
        <div className="lg:col-span-5">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.15 }} className="relative mx-auto max-w-[420px]">
            <motion.div
              variants={{ hidden: { clipPath: "inset(0% 0% 100% 0%)" }, show: { clipPath: "inset(0% 0% 0% 0%)" } }}
              transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
              className="arch relative aspect-[3/4.2] overflow-hidden bg-[#241914]"
            >
              <motion.img
                variants={{ hidden: { scale: 1.3 }, show: { scale: 1 } }}
                transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
                src="/img/ingredients.webp"
                alt="Oud, rose, ambre"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </motion.div>
            <div className="arch pointer-events-none absolute -inset-3 border border-[#C6A76A]/50" />
            <span className="absolute -bottom-10 end-0 font-arabic-display text-7xl text-[#C6A76A]/25 sm:text-8xl" aria-hidden>
              رويحة
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
